export default "/images/vendor/flag-icon-css/flags/4x3/pl.svg?7ea4b5b2df865bf73b06a50c1763b50e";